import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Wrapper, Label } from './styled';

const NoSearchResults = () => (
  <Wrapper>
    <Label><FormattedMessage id="app.nodata" /></Label>
  </Wrapper>
);

export default NoSearchResults;
